export default __webpack_public_path__ + "static/media/raro-ajuda.2847db68.webp";